import React from "react";

import Static from "../../lib/Static";
import Button from "../Button";
import InfoCard from "../InfoCard";
import Offices from "../Offices";
import Team from "../Team";
import TeamIcons from "../TeamIcons";
import style from "./Life.css";

const Life = ({}) => {
  const content = Static.pages.life;
  let teamsWithoutTalentPool = Static.teams.filter((team) => team.name !== "Talent Pool");

  return (
    <div>
      <div className={style.hero}>
        <div className={style.heroContent}>
          <h1 className={style.title}>{content.title}</h1>
          <Button
            to={"/openings/"}
            label={"Join the team"}
            styles={ { backgroundColor: "#002161" } } />
        </div>
      </div>
      <div className={style.content}>
        <div className={style.textRow}>
          <h3 className={style.aboutTitle}>
            {content.about.title}
          </h3>
          <div
            className={style.text}
            dangerouslySetInnerHTML={{ __html: content.about.body }}
          />
        </div>
      </div>
      <div className={style.content}>
        <div className={style.row}>
          {content.weAre.map((weAre, idx) =>
            <InfoCard
              key={idx}
              image={weAre.image}
              title={weAre.title}
              body={weAre.body}
              titleOffset={true}
            />
          )}
        </div>
      </div>
      <div className={style.europeOffices}>
        <div className={style.content}>
          <div className={style.row}>
            <Offices offices={Static.offices} />
          </div>
        </div>
      </div>

      <div className={style.content}>
        <div className={style.textRow}>
          <h3 className={style.valuesTitle}>
            {content.values.title}
          </h3>
          <div
            className={style.text}
            dangerouslySetInnerHTML={{ __html: content.values.body }}
          />
        </div>
      </div>
      <div className={style.content}>
        <div className={style.row}>
            {content.be.map((be, idx) =>
              <InfoCard
                key={idx}
                image={be.image}
                title={be.title}
                body={be.body}
                height={"50%"}
                width={"50%"}
              />
            )}
        </div>
      </div>
      <div className={style.lifeAt}>
        <div className={style.content}>
          <div className={style.lifeAtRow}>
            <div className={style.titleContent}>
              <h3 className={style.lifeAtTitle}>
                {content.lifeAt.title}
              </h3>
            </div>
            <div className={style.lifeAtCollage}>
              {content.lifeAt.images.map((image, idx) =>
                <img
                  key={idx}
                  className={style.lifeAtImage}
                  alt={image.title}
                  title={image.title}
                  src={`/img/jobs/life_at/${image.src}`} />
              )}
            </div>
            <div className={style.lifeAtText}>
              {content.lifeAt.body}
            </div>
          </div>
        </div>
      </div>
      <Team teams={teamsWithoutTalentPool} />
      <div className={style.findCareer}>
        <div className={style.findCareerContent}>
          <h3 className={style.findCareerTitle}>
            Find your next career
          </h3>
          <TeamIcons teams={teamsWithoutTalentPool} />
          <Button
            to={"/openings/"}
            label={"View all open positions"} />
        </div>
      </div>
    </div>
  );
};

export default Life;



// WEBPACK FOOTER //
// ./component/Life/index.js